import { css } from '@emotion/core';

import { Theme } from 'src/design-system/theme';
import { UploadState } from './UploadSystem';

export const uploadProgressProgressBar = (status: UploadState) => (theme: Theme) =>
  css`
    width: 100%;

    > div {
      width: 100%;
      border-radius: 9999px;
      overflow: hidden;
      background: transparent;
      border: 1px solid ${theme.colors.grey25};
      margin-bottom: 24px;

      > div {
        &::after {
          background: none;
        }

        ${status === UploadState.Processing &&
        `
          background-color: ${theme.colors.accent};
        `}

        ${status === UploadState.Succeeded &&
        `
          background-color: ${theme.colors.success};
        `}

      ${status === UploadState.Failed &&
        `
          background-color: ${theme.colors.error};
        `}
      }
    }
  `;

export const style = { uploadProgressProgressBar };
